import React, { useState } from 'react';
import { createI18nPaymentGateway } from 'i18n/i18n';
import { CacheProvider } from '@emotion/react';
import { createEmotionCache } from 'src/createEmotionCache';
import { ErrorBoundaryWithSentry } from 'elements/ErrorBoundary';
import { config as fontawesomeConfig } from '@fortawesome/fontawesome-svg-core';

import type { EmotionCache } from '@emotion/cache';
import type { AppProps } from 'next/app';

import '@fortawesome/fontawesome-svg-core/styles.css';

// hack for https://github.com/vercel/next.js/issues/20682
fontawesomeConfig.autoAddCss = false;

const clientSideEmotionCache = createEmotionCache();

export default function App({ Component, pageProps, emotionCache }: AppProps & { emotionCache?: EmotionCache }) {
    useState(createI18nPaymentGateway);

    return (
        <ErrorBoundaryWithSentry>
            <CacheProvider value={emotionCache ?? clientSideEmotionCache}>
                <Component {...pageProps} />
            </CacheProvider>
        </ErrorBoundaryWithSentry>
    );
}
